<template>
  <div class="flex flex-col">
    <div class="flex flex-row p-2"
      v-if="showPartitionName">
      <div class="text-black text-sm font-bold">
        Partition:
      </div>
      <div class="text-sm">{{ partitionName }}</div>
    </div>
    <div class="grid grid-cols-2 gap-1">
      <ol
        class="ml-2 mb-1 mt-2 space-y-2"
        v-if="showDistrictConsortiumColumn">
        <li class="flex items-center gap-1" v-if="showConsortium">
          <div class="text-black text-sm font-bold">
            Consortium:
          </div>
          <div class="text-sm truncate hover:text-clip">{{ consortiumName }}</div>
        </li>
        <li class="flex items-center gap-1" v-if="showDistrict">
          <div class="text-black text-sm font-bold">
            District:
          </div>
          <div class="text-sm truncate hover:text-clip">
            {{ districtCode }}
          </div>
        </li>
        <li class="flex items-center gap-1" v-if="showRequestingDistrict">
          <div class="text-black text-sm font-bold">
            Requesting:
          </div>
          <div class="text-sm truncate hover:text-clip">
            {{ requestingDistrictCode }}
          </div>
        </li>
        <li class="flex items-center gap-1" v-if="showResidentDistrict">
          <div class="text-black text-sm font-bold">
            Resident:
          </div>
          <div class="text-sm truncate hover:text-clip">
            {{ residentDistrictCode }}
          </div>
        </li>
      </ol>
      <ol class="ml-2 mb-1 mt-2 space-y-2">
        <li class="flex items-center gap-1">
          <div class="text-black text-sm font-bold">
            Internal ID:
          </div>
          <div class="text-sm overflow-visible">
            {{ item.internalId }}
          </div>
        </li>
        <li class="flex items-center gap-1">
          <div class="text-black text-sm font-bold">
            Student ID:
          </div>
          <div class="text-sm overflow-visible"
            v-if="item.studentId">
            {{ item.studentId }}
          </div>
          <div class="text-sm text-gray-300"
            v-else>
            N/A
          </div>
        </li>
        <li v-if="item.building" class="flex items-center gap-1">
          <div class="text-black text-sm font-bold">
            Building:
          </div>
          <div class="text-sm truncate hover:text-clip">
            {{ item.building.name }}
          </div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import partitions from '../../../services/partitions.js'

export default {
  components: {},
  props: {
    item: Object,
    caller: String,
    showDistrictConsortiumColumn: Boolean,
    showPartitionName: Boolean,
  },
  data() {
    return {
      partitionName: undefined
    }
  },
  methods: {
    async getPartitionName() {
      await partitions.getPartitionFromServer()
      this.partitionName = (await partitions.getPartitionName(this.item.partitionId))
    }
  },
  computed: {
    showConsortium() {
      return this.item.district === 'MN-0000NW' || this.item.district === 'MN-000BIA'
    },
    showDistrict() {
      return !this.showConsortium
    },
    showRequestingDistrict() {
      return this.item.district === 'MN-0000NW' || this.item.district === 'MN-000BIA'
    },
    showResidentDistrict() {
      return this.item.district === 'MN-0000NW'
    },
    districtCode() {
      return this.item.district
    },
    residentDistrictCode() {
      if (this.item.infoResidentDistrict) {
        return this.item.infoResidentDistrict
      } else {
        return ''
      }
    },
    requestingDistrictCode() {
      if (this.item.infoRequestingDistrict) {
        return this.item.infoRequestingDistrict
      } else {
        return ''
      }
    },
    consortiumName() {
      switch (this.item.district) {
      case 'MN-0000NW':
        return 'Northwest Suburban'
      case 'MN-000BIA':
        return 'Business Innovation Academy'
      default:
        return ''
      }
    }
  },
  mounted() {
    this.getPartitionName()
  },
  watch: {
    item() {
      this.getPartitionName()
    }
  },
}
</script>

<style></style>
